export default {
  title: "Sign in",

  input: {
    email: "Email address",
    password: "Password",
  },

  button: {
    submit: "Sign in",
    forgotPassword: "Forgot password",
  },

  warning: {
    noEmail: "Please fill in your email address.",
    noPassword: "Please fill in your password.",
  },

  error: {
    userNotFound: "Login details are incorrect.",
  },

  api: {
    login: {
      failed: "Incorrect login details.",
      email: {
        notNull: "Please fill in your email address.",
        invalid: "Invalid email address",
      },
      password: {
        notNull: "Please fill in your password.",
      },
    },
    cookie: {
      missing: "You've been logged out automatically.",
      invalid: "Your session has expired",
    },
  },
}
